import { defineMessages } from 'react-intl';

const trns = defineMessages({
  partnersTitle: {
    id: 'FzebmO',
    defaultMessage: 'Наші партнери'
  }
});

export default trns;
